import * as React from "react";
import { singleton } from "logic/singleton";
const LogViewStateContext = React.createContext(void 0);
export default singleton("contexts.enterprise.LogViewStateContext", () => LogViewStateContext);
